import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { ComponentRoutes } from "../models/constants/component-routes";
import { AuthStore } from "../stores/auth.store";

export const authorizedGuard: CanActivateFn = (route, state) => {
    const authStore: AuthStore = inject(AuthStore);
    const router: Router = inject(Router);

    if (authStore.isAuthorized()) {
        return true;
    } else {
        router.navigateByUrl(ComponentRoutes.auth.root);

        return false;
    }
};
